module.exports = __webpack_public_path__ + "static/media/favorite-bold.270c44c4.svg";